import { ReactComponent as ErrorIcon } from "assets/icons/error.svg"

import styles from "./styles.module.scss"
import { Typography } from "antd"
const { Title, Text } = Typography
interface IErrorLayout extends React.FC<React.PropsWithChildren> {
  Error: React.FC<React.PropsWithChildren>
  Title: React.FC<React.PropsWithChildren>
  Subtitle: React.FC<React.PropsWithChildren>
  Actions: React.FC<React.PropsWithChildren>
  Icon: React.FC<React.PropsWithChildren>
}
const ErrorLayout: IErrorLayout = ({ children }) => {
  return <div className={styles.container}>{children}</div>
}

ErrorLayout.Icon = ({ children }) => (
  <div className={styles.icon}>
    {children || (
      <ErrorIcon width="72" height="72" fill="var(--color-danger)" />
    )}
  </div>
)

ErrorLayout.Error = ({ children }) => <Title level={5}>{children}</Title>
ErrorLayout.Title = ({ children }) => (
  <Title className={styles.title} level={2}>
    {children}
  </Title>
)
ErrorLayout.Subtitle = ({ children }) => (
  <Text type="secondary">{children}</Text>
)
ErrorLayout.Actions = ({ children }) => (
  <div className={styles.actions}>{children}</div>
)

export default ErrorLayout
